import React from "react"
import PropTypes from "prop-types"
import success from "@irati/ui/images/success.svg"
import successTickets from "@irati/ui/images/success-tickets.svg"

const DealSuccessLogo = ({vouchers}) => {
  let img = success
  if (Array.isArray(vouchers) && vouchers.length > 0) {
    img = successTickets
  }
  return (
    <img src={img} alt="success" className="successImage" />
  )
}

DealSuccessLogo.propTypes = {
  vouchers: PropTypes.array.isRequired
}

export default DealSuccessLogo
